import { cn } from '@/lib/utils';

export default function TextHuge({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h1 className={cn('text-h2 font-normal lg:text-huge', className)}>{children}</h1>;
}
